import React, { useState } from 'react';
import { Form, Link, useNavigate } from 'react-router-dom';
import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { LoginForm, ProFormText } from '@ant-design/pro-components';
import { Alert, theme, Typography } from 'antd';

import PageTitle from '../Layouts/PageTitle';
import { LoginUserModel } from '../../types/LoginUserModel.type';
import { useAuth } from '../../contexts';
import './LoginPage.scss';

const { Text } = Typography;

export const LoginPage = () => {
  const [errorMessage, setErrorMessage] = useState(null);
  const { token } = theme.useToken();
  const navigate = useNavigate();
  const { login } = useAuth();

  const getErrorMessageFromResponse = (error: any) => {
    if (error?.response?.data?.message) {
      return error.response.data.message;
    }
    return error.message;
  };

  const handleLogin = async (values: LoginUserModel) => {
    try {
      await login(values);
      navigate('/home');
    } catch (error) {
      const errorMessageFromResponse = getErrorMessageFromResponse(error);
      setErrorMessage(errorMessageFromResponse);
    }
  };

  return (
    <PageTitle title="Login">
      <div className="login-board-wrapper" style={{ backgroundColor: token.colorBgContainer }} data-test="login-form-wrapper">
        <LoginForm
          logo={<img alt="logo" src="LHPH_Logo.png" />}
          subTitle={'Log in to your account'}
          submitter={{
            searchConfig: {
              submitText: 'Login',
            },
          }}
          onFinish={handleLogin}
        >
          <ProFormText
            name="userIdentifier"
            fieldProps={{
              size: 'large',
              prefix: <UserOutlined className={'prefixIcon'} />,
              'data-test': 'username',
            }}
            placeholder={'username or email address'}
            rules={[
              {
                required: true,
                message: 'Please enter your username or email!',
              },
            ]}
          />
          <ProFormText.Password
            name="password"
            fieldProps={{
              size: 'large',
              prefix: <LockOutlined className={'prefixIcon'} />,
              strengthText:
                'Password should contain numbers, letters and special characters, at least 8 characters long.',
              'data-test': 'password',
            }}
            placeholder={'password'}
            rules={[
              {
                required: true,
                message: 'Please enter your password！',
              },
            ]}
          />
          <div
            style={{
              marginBlockEnd: 24,
              float: 'right',
            }}
          >
            <Text>
              <Link to="/forgot-password">Forgot password?</Link>
            </Text>
          </div>
        </LoginForm>

        {errorMessage && (
          <Alert message={errorMessage} type="error" style={{ textAlign: 'center' }} />
        )}
      </div>
    </PageTitle>
  );
};
